import { useJobProgress } from 'src/JobProgressContext';
import { getBulkDelistStatus, getBulkArchiveStatus } from 'src/redux/slices/listing';

import MergeWidget from 'src/sections/merge/components/merge-widget';
import BulkEditProgress from 'src/sections/listing/bulk-edit-progress';
import { InkfrogImportProgress } from 'src/sections/listing/inkfrog-import';
import DelistRelistProgress from 'src/sections/listing/delist-relist-progress';
import BulkDelistResultsDialog from 'src/sections/listing/bulk-delist-results-dialog';
import BulkArchiveResultsDialog from 'src/sections/listing/bulk-archive-results-dialog';
import DelistRelistResultsDialog from 'src/sections/listing/delist-relist-results-dialog';
import BulkCrossListWidget from 'src/sections/bulk-cross-list/components/bulk-cross-list-widget';
import BulkJobProgress, { DELIST_JOB_COPY, ARCHIVE_JOB_COPY } from 'src/sections/listing/bulk-job-progress';

export default function GlobalJobProgress() {
  const {
    bulkEditBatchId,
    delistRelistBatchId,
    delistRelistResults,
    delistRelistResultsOpen,
    clearBulkEdit,
    handleDelistRelistComplete,
    clearDelistRelist,
    closeDelistRelistResults,
    bulkArchiveBatchId,
    bulkArchiveResults,
    bulkArchiveResultsOpen,
    handleBulkArchiveComplete,
    clearBulkArchive,
    closeBulkArchiveResults,
    bulkDelistBatchId,
    bulkDelistResults,
    bulkDelistResultsOpen,
    handleBulkDelistComplete,
    clearBulkDelist,
    closeBulkDelistResults,
    inkfrogImportJobId,
    clearInkfrogImport,
  } = useJobProgress();

  return (
    <>
      {/* Bulk Edit Progress - floating panel showing job status */}
      <BulkEditProgress batchId={bulkEditBatchId} onClose={() => clearBulkEdit(true)} />

      {/* Delist & Relist Progress - floating panel showing job status */}
      <DelistRelistProgress
        batchId={delistRelistBatchId}
        onComplete={handleDelistRelistComplete}
        onClose={clearDelistRelist}
      />

      {/* Delist & Relist Results Dialog - shows detailed results */}
      <DelistRelistResultsDialog
        open={delistRelistResultsOpen}
        onClose={() => closeDelistRelistResults(true)}
        results={delistRelistResults}
      />

      {/* Bulk Cross-List Progress - floating panel showing job status */}
      <BulkCrossListWidget />

      {/* Merge duplicates - floating panel showing the run tracked by MergeRunProvider */}
      <MergeWidget />

      {/* Bulk Archive Progress - floating panel showing archive job status */}
      <BulkJobProgress
        batchId={bulkArchiveBatchId}
        getStatus={getBulkArchiveStatus}
        copy={ARCHIVE_JOB_COPY}
        onComplete={handleBulkArchiveComplete}
        onClose={clearBulkArchive}
      />

      {/* Bulk Archive Results Dialog - shows detailed results */}
      <BulkArchiveResultsDialog
        open={bulkArchiveResultsOpen}
        onClose={() => closeBulkArchiveResults(true)}
        results={bulkArchiveResults}
      />

      {/* Delist Progress - floating panel showing delist job status */}
      <BulkJobProgress
        batchId={bulkDelistBatchId}
        getStatus={getBulkDelistStatus}
        copy={DELIST_JOB_COPY}
        onComplete={handleBulkDelistComplete}
        onClose={clearBulkDelist}
      />

      {/* Delist Results Dialog - shows detailed results */}
      <BulkDelistResultsDialog
        open={bulkDelistResultsOpen}
        onClose={() => closeBulkDelistResults(true)}
        results={bulkDelistResults}
      />

      {/* Inkfrog Import Progress - floating panel */}
      <InkfrogImportProgress
        jobId={inkfrogImportJobId}
        onClose={() => clearInkfrogImport(true)}
      />
    </>
  );
}
